export { default } from './PageAudioguides.vue'
